import React, { useState, useEffect } from "react";

function NeighborhoodPage(props) {
  //   console.log(props.community, "community");
  const [state, setState] = useState({
    latitude: 0.0,
    longitude: 0.0,
    communityObject: [],
    communityImages: [],
    communityAmenities: [],
    showlist: false,
    showSearch: false,
    directionsService: {},
    directionsDisplay: {},
    destinationAdd: "",
    types: [
      {
        name: "Restaurants",
        type: "restaurant",
        fa: "fas fa fa-cutlery",
        icon: "/assets/newUI-images/explore_icons/restarent.svg",
      },
      {
        name: "Bars",
        type: "bar",
        fa: "fas fa fa-beer",
        icon: "/assets/newUI-images/explore_icons/bars.svg",
      },
      {
        name: "Groceries",
        type: "supermarket",
        fa: "fas fa fa-shopping-cart",
        icon: "/assets/newUI-images/explore_icons/groceries.svg",
      },
      {
        name: "Park",
        type: "park",
        fa: "fas fa fa-tree",
        icon: "/assets/newUI-images/explore_icons/parks.svg",
      },
      {
        name: "Shopping",
        type: "shopping_mall",
        fa: "fas fa fa-shopping-bag",
        icon: "/assets/newUI-images/explore_icons/shopping.svg",
      },
      {
        name: "Entertainment",
        type: "night_club",
        fa: "fas fa fa-film",
        icon: "/assets/newUI-images/explore_icons/entertainment.svg",
      },
    ],
    type: "restaurant",
    activeNumber: -1,
    location: [],
    generalTab: false,
  });

  useEffect(() => {
    if (props.community) {
      // Reset state to initial values when community changes
      updateState({
        communityObject: props.community,
        latitude: props.community.latitude,
        longitude: props.community.longitude,
        showlist: false,
        showSearch: false,
        markerList: [],
        directionsService: {},
        directionsDisplay: {},
        destinationAdd: "",
        activeNumber: -1,
        location: [],
        generalTab: false,
        type: "restaurant",
      });

      // Wait for both Google Maps API and DOM element to be ready
      const checkAndInitMap = () => {
        if (typeof window.google === "undefined") {
          console.log("Google Maps API not loaded yet");
          return false;
        }

        const mapElement = document.getElementById(
          "map" + props.community.community_id
        );
        if (!mapElement) {
          console.log("Map container not found yet");
          return false;
        }

        console.log("Google Maps API and map element are ready");
        return true;
      };
      typeView();
      // Try to initialize map immediately if everything is ready
      if (checkAndInitMap()) {
        methodx(props.community);
      } else {
        // Otherwise set up an interval to check periodically
        const interval = setInterval(() => {
          if (checkAndInitMap()) {
            clearInterval(interval);
            methodx(props.community);
          }
        }, 300); // Check every 300ms

        // Clean up interval on component unmount
        return () => clearInterval(interval);
      }
    }
  }, [props.community]);

  const updateState = (updateObj) => {
    setState((prev) => ({ ...prev, ...updateObj }));
  };

  const CustomZoomInControl = (controlDiv, map) => {
    // Set CSS for the control border
    var controlUI = document.createElement("div");

    controlUI.style.cursor = "pointer";
    controlUI.style.display = "-webkit-inline-box";
    controlUI.style.margin = "18px 10px";
    controlUI.style.width = "30px";
    controlUI.style.height = "30px";
    controlDiv.appendChild(controlUI);
    // Set CSS for the control interior
    var controlText = document.createElement("div");
    controlText.innerHTML += `<img style="height:30px;width:30px;margin:0"  src='/assets/newUI-images/plus.svg' />`;
    controlUI.appendChild(controlText);

    // Setup the click event listeners
    google.maps.event.addDomListener(controlUI, "click", function () {
      map.setZoom(map.getZoom() + 1);
    });

    // Set CSS for the control border
    var controlUILeft = document.createElement("div");

    controlUILeft.style.display = "-webkit-inline-box";
    controlUILeft.style.marginLeft = "10px";
    controlUILeft.style.cursor = "pointer";
    controlUILeft.style.width = "30px";
    controlUILeft.style.height = "30px";
    controlDiv.appendChild(controlUILeft);

    var controlTextLeft = document.createElement("div");

    controlTextLeft.innerHTML += `<img style="height:30px;width:30px;margin:0"  src='/assets/newUI-images/minus.svg' />`;
    controlUILeft.appendChild(controlTextLeft);

    // Setup the click event listeners
    google.maps.event.addDomListener(controlUILeft, "click", function () {
      map.setZoom(map.getZoom() - 1);
    });
  };

  const methodx = async (communityObject) => {
    try {
      // Clear existing markers
      if (state.markerList && state.markerList.length > 0) {
        state.markerList.forEach((marker) => marker.setMap(null));
        updateState({ markerList: [] });
      }

      // Reset state
      updateState({
        directionsService: {},
        directionsDisplay: {},
        destinationAdd: "",
      });

      // Clear distance display if it exists
      const distanceElement = document.getElementById("dvDistance");
      if (distanceElement) {
        distanceElement.innerHTML = "";
      }

      // Clear places input if jQuery is available
      if (window.$ && $("#txtPlaces").length) {
        $("#txtPlaces").val("");
      }

      // Check if map container exists
      const mapElementId = "map" + communityObject.community_id;
      const mapElement = document.getElementById(mapElementId);

      if (!mapElement) {
        console.error(`Map container #${mapElementId} not found in DOM`);
        return;
      }

      // Validate coordinates
      const lat = Number(communityObject.latitude);
      const lng = Number(communityObject.longitude);

      if (isNaN(lat) || isNaN(lng)) {
        console.error("Invalid coordinates:", lat, lng);
        return;
      }

      const locations = { lat, lng };
      console.log(locations, "locations");

      // Create map with error handling
      try {
        const map = new google.maps.Map(mapElement, {
          zoom: 7,
          center: locations,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          backgroundColor: "#eeeeee",
          disableDefaultUI: true,
        });

        // Apply styling
        const style = [
          {
            elementType: "geometry",
            stylers: [{ saturation: -40 }],
          },
        ];

        const mapType = new google.maps.StyledMapType(style, {
          name: "Grayscale",
        });
        map.mapTypes.set("grey", mapType);
        map.setMapTypeId("grey");

        // Add custom zoom controls
        const customZoomInControlDiv = document.createElement("div");
        CustomZoomInControl(customZoomInControlDiv, map);
        customZoomInControlDiv.index = 1;
        map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
          customZoomInControlDiv
        );

        // Update state with map reference
        updateState({ customMap: map });

        // Set up directions
        const directionsService = new google.maps.DirectionsService();
        const directionsDisplay = new google.maps.DirectionsRenderer();

        updateState({
          directionsService: directionsService,
          directionsDisplay: directionsDisplay,
        });

        // Prepare info window content
        const image_name = communityObject.image_name;
        const communityName = communityObject.community_name;
        const communityAddress = communityObject.address;
        const communityLat = communityObject.latitude;
        const communityLong = communityObject.longitude;
        const communityCity = communityObject.city_name;
        const communityState = communityObject.state_name;
        const communityZipcode = communityObject.ZipCode;

        const detailAddress =
          communityAddress +
          ", " +
          communityCity +
          ", " +
          communityState +
          " " +
          communityZipcode;

        const contentString =
          '<div id="content">' +
          '<div id="siteNotice">' +
          "</div>" +
          '<div id="bodyContent">' +
          '<div class="bodycontentimg"><img width="100px" height="100px" src="' +
          image_name +
          '" /> </div>' +
          "<h4>" +
          communityName +
          "</h4>" +
          "<p>" +
          detailAddress +
          ' </p><a href="https://www.google.com/maps?daddr=' +
          communityLat +
          "," +
          communityLong +
          '" target="_blank">Get driving directions</a>' +
          "</div>" +
          "</div>";

        // Set up directions display
        directionsDisplay.setMap(map);

        // Create info window
        const infowindow = new google.maps.InfoWindow({
          content: contentString,
        });

        // Add marker
        const marker = new google.maps.Marker({
          position: locations,
          icon: "/assets/newUI-images/explore_icons/map_icon.svg",
          map: map,
        });

        // Add click listener
        marker.addListener("click", function () {
          infowindow.open(map, marker);
        });

        // Force a resize event to ensure map renders correctly
        setTimeout(() => {
          google.maps.event.trigger(map, "resize");
          map.setCenter(locations);
        }, 100);
      } catch (mapError) {
        console.error("Error creating Google Map:", mapError);
      }
    } catch (error) {
      console.error("Error in methodx:", error);
    }
  };

  const typeView = async () => {
    $(".nav-link").removeClass("active");
    $("#name").addClass("active");
    updateState({
      showlist: false,
      showSearch: false,
    });
    methodx(props.community);
  };

  const distanceCal = (lat1, lon1, lat2, lon2, unit) => {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344;
    }
    if (unit == "N") {
      dist = dist * 0.8684;
    }
    return dist.toFixed(2);
  };

  const getDistance = async (location) => {
    const updatedLocations = [];

    for (let i = 0; i < location.length; i++) {
      const loc = location[i];
      let distanceVal = 0;

      if (
        loc.latitude !== "" &&
        loc.latitude !== undefined &&
        loc.latitude !== null &&
        loc.longitude !== "" &&
        loc.longitude !== undefined &&
        loc.longitude !== null
      ) {
        distanceVal = distanceCal(
          state.latitude,
          state.longitude,
          loc.latitude,
          loc.longitude
        );
      }

      // Add distance to the location object
      updatedLocations.push({
        ...loc,
        distance: parseFloat(distanceVal),
      });
    }

    // Sort by distance
    const sortedLocations = _.sortBy(updatedLocations, "distance");

    // Update the state once all calculations are done
    updateState({
      location: sortedLocations,
    });
  };

  const loadPlacesWithMarkers = async (index, type) => {
    const markers = [];

    const pyrmont = {
      lat: Number(state.latitude),
      lng: Number(state.longitude),
    };

    if (isNaN(pyrmont.lat) || isNaN(pyrmont.lng)) {
      console.error("Invalid coordinates:", pyrmont);
      return;
    }

    const mapElement = document.getElementById(
      "map" + state.communityObject.community_id
    );
    if (!mapElement) {
      console.error("Map container not found!");
      return;
    }

    const map = new google.maps.Map(mapElement, {
      zoom: 14,
      center: pyrmont,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      backgroundColor: "#eeeeee",
      disableDefaultUI: true,
    });

    const style = [
      {
        elementType: "geometry",
        stylers: [{ saturation: -40 }],
      },
    ];

    const mapType = new google.maps.StyledMapType(style, { name: "Grayscale" });
    map.mapTypes.set("grey", mapType);
    map.setMapTypeId("grey");

    const customZoomInControlDiv = document.createElement("div");
    CustomZoomInControl(customZoomInControlDiv, map);
    customZoomInControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
      customZoomInControlDiv
    );

    updateState({ map });

    const propertyMarker = new google.maps.Marker({
      map: map,
      position: pyrmont, // Using the same location as center
      icon: "/assets/newUI-images/explore_icons/map_icon.svg",
      zIndex: 999, // Keep property marker on top
    });

    // Add info window for property
    const propertyInfoWindow = new google.maps.InfoWindow();
    const propertyContent =
      '<div id="content">' +
      '<div id="siteNotice">' +
      "</div>" +
      '<div id="bodyContent">' +
      '<div class="bodycontentimg"><img width="100px" height="100px" src="' +
      state.communityObject.image_name +
      '" /> </div>' +
      "<h4>" +
      state.communityObject.community_name +
      "</h4>" +
      "<p>" +
      state.communityObject.address +
      ' </p><a href="https://www.google.com/maps?daddr=' +
      state.communityObject.latitude +
      "," +
      state.communityObject.longitude +
      '" target="_blank">Get driving directions</a>' +
      "</div>" +
      "</div>";

    google.maps.event.addListener(propertyMarker, "click", function () {
      propertyInfoWindow.setContent(propertyContent);
      propertyInfoWindow.open(map, propertyMarker);
    });

    // Store property marker
    updateState({
      propertyMarker: propertyMarker,
    });

    const service = new google.maps.places.PlacesService(map);
    const request = {
      location: pyrmont,
      radius: 2000,
      type: type,
    };

    service.nearbySearch(request, async (data, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        const location = [];
        const infowindow = new google.maps.InfoWindow();
        const results = _.orderBy(data, ["name"], ["asc"]);

        results.forEach((place, i) => {
          location.push({
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            name: place.name,
            address: place.vicinity,
          });

          const marker = new google.maps.Marker({
            map,
            position: place.geometry.location,
            icon: state.types[index].icon,
          });

          google.maps.event.addListener(marker, "click", () => {
            const hasPhoto = place.hasOwnProperty("photos");
            const imageHTML = hasPhoto
              ? `<img src="${place.photos[0].getUrl()}" alt="Loading" width="160" height="80" />`
              : "";

            const contentString = `
              <h3 style="font-size:20px; text-align:center">${place.name}</h3>
              ${imageHTML}
              <div>
                <p>${place.vicinity}</p>
                <a href="https://www.google.com/maps/place/${place.vicinity}" target="_blank">Get Directions</a>
              </div>
            `;

            updateState({ activeNumber: place.name });
            infowindow.setContent(contentString);
            infowindow.open(map, marker);
          });

          markers.push(marker);
        });

        updateState({
          location: location,
          markerList: markers,
        });

        await getDistance(location);
      }
    });
  };

  const onetype = async (row, type) => {
    console.log(row.type, "row.type", type);

    $(".nav-link").removeClass("active");
    $("#" + row.name).addClass("active");
    updateState({
      type: row.type,
      showlist: true,
      typeName: row.name,
      typeicon: type,
      showSearch: false,
      location: [],
    });
    await loadPlacesWithMarkers(type, row.type);
  };
  const destinationLocation = () => {
    var address = "";
    const _this = this;
    var places = new google.maps.places.Autocomplete(
      document.getElementById("txtPlaces")
    );
    google.maps.event.addListener(places, "place_changed", function () {
      var place = places.getPlace();
      address = place.formatted_address;
      updateState({ destinationAdd: address });
    });
  };
  const searchPlace = () => {
    updateState({
      showSearch: true,
      showlist: true,
    });
  };
  const handleFormSubmit = async () => {
    await searchPlace();

    const locations = {
      lat: Number(state.communityObject.latitude),
      lng: Number(state.communityObject.longitude),
    };

    // Initialize map
    const customMap = new google.maps.Map(
      document.getElementById("map" + state.communityObject.community_id),
      {
        zoom: 7,
        center: locations,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        backgroundColor: "#eeeeee",
        disableDefaultUI: true,
        clickableIcons: false,
      }
    );

    // Grayscale map style
    const style = [
      {
        elementType: "geometry",
        stylers: [{ saturation: -40, visibility: "on" }],
      },
    ];

    const mapType = new google.maps.StyledMapType(style, { name: "Grayscale" });
    customMap.mapTypes.set("grey", mapType);
    customMap.setMapTypeId("grey");

    // Custom Zoom Control
    const customZoomInControlDiv = document.createElement("div");
    CustomZoomInControl(customZoomInControlDiv, customMap);
    customZoomInControlDiv.index = 1;
    customMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
      customZoomInControlDiv
    );

    updateState({ customMap });

    const directionsService = new google.maps.DirectionsService();

    const communityLat = Number(state.communityObject.latitude);
    const communityLong = Number(state.communityObject.longitude);

    const request = {
      origin: { lat: communityLat, lng: communityLong },
      destination: state.destinationAdd,
      travelMode: google.maps.DirectionsTravelMode.DRIVING,
    };

    directionsService.route(request, function (response, status) {
      if (status === google.maps.DirectionsStatus.OK) {
        // Render route
        new google.maps.DirectionsRenderer({
          map: customMap,
          directions: response,
          suppressMarkers: true,
        });

        const leg = response.routes[0].legs[0];

        // Commute info
        const distance = leg.distance.text;
        const duration = leg.duration.text;

        const dvDistance = document.getElementById("dvDistance");
        dvDistance.innerHTML = `
          <h4>Your Commute Summary</h4>
          <p>Drive Time: ${duration}</p>
          <p>Distance: ${distance}</p>
        `;

        // Start & End Marker Icons
        const icons = {
          start: new google.maps.MarkerImage(
            "/assets/newUI-images/explore_icons/map_icon.svg"
          ),
          end: new google.maps.MarkerImage(
            "https://suiteam-website.s3.us-west-1.amazonaws.com/new/icons/location_pin_2.svg"
          ),
        };

        // Marker Helper
        const makeMarker = (position, icon, title, map) =>
          new google.maps.Marker({
            position,
            map,
            icon,
            title,
          });

        // Place Markers
        makeMarker(leg.start_location, icons.start, "Start", customMap);
        makeMarker(leg.end_location, icons.end, "End", customMap);
      } else {
        console.error("Directions request failed due to:", status);
      }
    });
  };
  const flyToPlace = (row, index, type) => {
    var latLng = new google.maps.LatLng(row.latitude, row.longitude);
    state.map.panTo(latLng);
    const placemarker =
      type == "locations" ? state.markerList : state.placeSearchedMarkers;
    google.maps.event.trigger(placemarker[index], "click");
    updateState({ activeNumber: row.name });
  };
  const resetData = async () => {
    methodx(props.community);
  };
  var finalLocation = _.orderBy(state.location, ["name"], ["asc"]);
  return (
    <div className="SAweb_neighbourhood pb-5 quoteOption">
      <div className="  ">
        <h3 className="ps-3">Neighborhood</h3>
        <ul className="nav nav-tabs ">
          <li>
            <button
              className="nav-link active"
              onClick={() => typeView()}
              id="name"
              data-toggle="tab"
              data-target="#commute"
              type="button"
              role="tab"
              aria-controls="commute"
              aria-selected="false"
            >
              Commute
            </button>
          </li>
          {state.types.map((row, index) => {
            return (
              <li key={index} onClick={() => onetype(row, index)}>
                <button
                  className="nav-link "
                  id={row.name}
                  aria-selected="true"
                >
                  {row.name}
                </button>
              </li>
            );
          })}
        </ul>

        <div className="tab-content myTabContentVIew ">
          <div
            className="tab-pane fade in active"
            id="commute"
            role="tabpanel"
            aria-labelledby="commute-tab"
          >
            <div className="">
              {state.showlist && !state.showSearch ? (
                <div className="">
                  <ul className="distanceList">
                    {finalLocation.map((row, index) => {
                      return (
                        <li
                          className={
                            state.activeNumber == row.name
                              ? "item test"
                              : "item"
                          }
                          key={index}
                          onClick={() => flyToPlace(row, index, "locations")}
                        >
                          <p>
                            {" "}
                            {row.name} <span>{row.address}</span>{" "}
                          </p>
                          <p> {row.distance} mi</p>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                <div className="tabsView">
                  <h3>What’s My Commute?</h3>
                  <input
                    type="text"
                    id="txtPlaces"
                    placeholder="Enter a location"
                    onChange={() => destinationLocation()}
                  />
                  <div className="view-btns">
                    <button
                      type="button"
                      className="btn black-btn"
                      onClick={() => handleFormSubmit()}
                    >
                      Search
                    </button>
                    <button
                      type="button"
                      className="btn btn-border-black"
                      onClick={() => resetData()}
                    >
                      Reset
                    </button>
                  </div>
                  <div id="dvDistance"></div>
                </div>
              )}

              <div
                id={"map" + state.communityObject.community_id}
                className="map-alignment"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NeighborhoodPage;
